import uploadImage from '../uploadImage';

export default async (story: any) => {
  const transformedStory = [];
  const arraylength = story.length;
  for (let i = 0; i < arraylength; i += 1) {
    const storyNode = story[i];
    if (
      storyNode.type === 'image' &&
      !new RegExp(/(jpg|png|gif|svg)$/).test(storyNode.src)
    ) {
      // eslint-disable-next-line
      const path = await uploadImage(storyNode.src);
      transformedStory.push({ ...storyNode, src: path });
    } else {
      transformedStory.push(storyNode);
    }
  }
  return transformedStory;
};
